export enum BuiltInPropertyDef {
  ObjectID                    = -102,
  NameOrTitle                 = 0,
  Created                     = 20,
  LastModified                 = 21,
  SingleFileObject            = 22,
  LastModifiedBy               = 23,
  StatusChanged               = 24,
  CreatedBy                   = 25,
  Keywords                    = 26,
  Deleted                     = 27,
  DeletedBy                   = 28,
  VersionLabel                = 29,
  SizeOnServerThisVersion     = 30,
  SizeOnServerAllVersions     = 31,
  MarkedForArchiving          = 32,
  VersionComment              = 33,
  Comment                     = 33,
  TraditionalFolder           = 34,
  CreatedFromExternalLocation = 35,
  AdditionalClasses           = 36,
  IsTemplate                  = 37,
  Workflow                     = 38,
  State                       = 39,
  StateEntered                = 40,
  AssignmentDescription       = 41,
  Deadline                    = 42,
  MonitoredBy                 = 43,
  AssignedTo                  = 44,
  CompletedBy                 = 45,
  CollectionMemberDocuments   = 46,
  CollectionMemberCollections = 47,
  Constituent                 = 48,
  OriginalPath                = 75,
  Reference                   = 76,
  OriginalPath2               = 77,
  OriginalPath3               = 78,
  WorkflowAssignment           = 79,
  AccessedByMe                = 81,
  FavoriteView                = 82,
  MessageID                   = 83,
  InReplyTo                   = 84,
  InReplyToReference          = 85,
  SignatureManifestation      = 86,
  ReportURL                   = 87,
  ReportPlacement             = 88,
  ObjectChanged               = 89,
  ACLChanged                  = 90,
  VersionLabelChanged         = 91,
  VersionCommentChanged       = 92,
  DeletionStatusChanged       = 93,
  VaultGUID                   = 94,
  SharedFiles                 = 95,
  ConflictResolved             = 96,
  RejectedBy                  = 97,
  Completed                   = 98,
  StateTransition             = 99,
  Class                       = 100,
  ClassGroups                 = 101,
  Repository                  = 102,
  Location                    = 103
}

export const buildinPropertyToString = (propertyDef: BuiltInPropertyDef): string => {
  return BuiltInPropertyDef[propertyDef];
};

export const getValueByKeyForBuiltInPropertyDef = (value: string): number => {
  let number = Object.entries(BuiltInPropertyDef).find(([key, val]) => key === value)?.[1];
  return number as number;
}

export const stringToBuiltinProperty = (propertyName: string): BuiltInPropertyDef => {
  const lowerCasePropertyName = propertyName.toLowerCase();
  for(const property in BuiltInPropertyDef) {
    if(property.toLowerCase() === lowerCasePropertyName) {
      return (BuiltInPropertyDef as unknown)[property];
    }
  }
  return undefined;
};

export const isBuildinProperty = (propertyNameOrAlias: string): boolean => {
  return stringToBuiltinProperty(propertyNameOrAlias) !== undefined;
}
